import { useEffect } from 'react';
import { usePublicBrandingQuery } from './api.js';

function darken(hex: string, amount: number): string {
  const n = Number.parseInt(hex.slice(1), 16);
  if (Number.isNaN(n)) return hex;
  const channel = (shift: number) => Math.max(0, ((n >> shift) & 255) - amount).toString(16).padStart(2, '0');
  return `#${channel(16)}${channel(8)}${channel(0)}`;
}

/**
 * Tailwind v4 compiles the `@theme` tokens in `packages/ui/src/tokens.css`
 * into real `--color-*` custom properties on `:root`; every `bg-primary` /
 * `text-primary-soft` / etc. utility just references `var(--color-primary)`.
 * Overriding that variable here re-themes the whole app at runtime with no
 * rebuild — the standard way to make a Tailwind v4 app admin-recolourable.
 */
export function useApplyBranding() {
  const { data } = usePublicBrandingQuery();

  useEffect(() => {
    if (!data) return;
    const root = document.documentElement.style;
    root.setProperty('--color-primary', data.accentColor);
    root.setProperty('--color-primary-hover', darken(data.accentColor, 24));
    document.title = data.productName;
  }, [data]);
}
